export var Name = function(nameData) {
    var nameInfo = {};
    
    // Constructor
    if (nameData) {
        nameInfo.given = nameData.given;
        nameInfo.family = nameData.family;
    }

    // -----------------------------------------------------
    //
    //                 Public Methods
    //
    // -----------------------------------------------------
    nameInfo.getFormattedName = function() {
        var name = '';

        if (nameInfo.given) {
            name += nameInfo.given;
        }
        if (nameInfo.family) {
            if (name.length > 0) {
                name += ' ' + nameInfo.family;
            } else {
                name += nameInfo.family;
            }
        }

        return name;
    };
    
    // -----------------------------------------------------
    //
    //                 Private Methods
    //
    // -----------------------------------------------------
    
    return nameInfo;
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/models/name.js
// module id = 193
// module chunks = 0